import { render } from "./MarketingContentNode.vue?vue&type=template&id=2cfc4303"
import script from "./MarketingContentNode.vue?vue&type=script&lang=js"
export * from "./MarketingContentNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__